import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formValueSelector } from 'redux-form';
import { ErrorPage } from '@components/_shared/Error/ErrorPage';
import { recordApplyEvent } from '@utils/recordEvent';

const isSyntheticTest = window._DATADOG_SYNTHETICS_BROWSER !== undefined;

// Dedup guard — React can invoke componentDidCatch more than once for a single
// crash (recovery re-renders, cascading boundaries), and crash-retry loops
// re-track the identical error every few seconds. One event per distinct
// error per window is enough; Datadog RUM keeps the full error stream.
let lastTrackedErrorKey = null;
let lastTrackedErrorTime = 0;
const ERROR_DEDUP_WINDOW_MS = 10000;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    (async () => {
      try {
        if (!isSyntheticTest && error) {
          // Error instances JSON-serialize to {} (message/stack are
          // non-enumerable), which made every tracked error payload look
          // identical — extract the useful fields explicitly.
          const payload = {
            message: (error && error.message) || String(error),
            stack: ((error && error.stack) || '').slice(0, 500),
            componentStack: ((errorInfo && errorInfo.componentStack) || '').slice(0, 500),
          };
          const key = `${payload.message}|${payload.componentStack}`;
          const now = Date.now();
          if (key === lastTrackedErrorKey && now - lastTrackedErrorTime < ERROR_DEDUP_WINDOW_MS) {
            console.error('[ErrorBoundary] componentDidCatch (duplicate, not tracked): ', error, errorInfo);
            return;
          }
          lastTrackedErrorKey = key;
          lastTrackedErrorTime = now;

          analytics.track('Apply Error Boundary error', payload);
          recordApplyEvent('Apply Error Boundary error', payload);
          console.error('[ErrorBoundary] componentDidCatch: ', error, errorInfo);
        }
      } catch (e) {
        console.error('ErrorBoundary try-catch failed: ', e);
      }
    })();
  }

  render() {
    if (this.state.error) {
      const { email, first, last } = this.props;

      //render fallback UI
      return <ErrorPage />;
    } else {
      return this.props.children;
    }
  }
}

const selector = formValueSelector('application');

const mapStateToProps = (state) => {
  return {
    business_id: selector(state, 'business_id'),
    contact_id: selector(state, 'owner_1_id'),
    mobile: selector(state, 'owner_1_mobile'),
    email: selector(state, 'owner_1_email'),
    first: selector(state, 'owner_1_first'),
    last: selector(state, 'owner_1_last'),
  };
};

ErrorBoundary = connect(mapStateToProps)(ErrorBoundary);

export default withRouter(ErrorBoundary);
